import React, { useState } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-43">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-44" />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" data-id="element-45">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-stone-200" data-id="element-46">
          <h2 className="text-xl font-serif font-bold text-stone-900" data-id="element-47">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-stone-100 transition-colors text-stone-500 hover:text-stone-700" data-id="element-48">
            <X className="w-5 h-5" data-id="element-49" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[60vh] text-stone-600 leading-relaxed" data-id="element-50">
          {children}
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <>
      <footer className="bg-stone-900 text-stone-500 py-8 px-4 border-t border-stone-800" data-id="element-51">
        <div className="max-w-3xl mx-auto text-center" data-id="element-52">
          <p className="mb-4 text-sm" data-id="element-53">
            © {new Date().getFullYear()} Cuidador Sin Caos. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center justify-center gap-4 text-sm" data-id="element-54">
            <button onClick={() => setShowTerms(true)} className="hover:text-stone-300 transition-colors underline underline-offset-2" data-id="element-55">
              Términos y Condiciones
            </button>
            <span className="text-stone-700" data-id="element-56">•</span>
            <button onClick={() => setShowPrivacy(true)} className="hover:text-stone-300 transition-colors underline underline-offset-2" data-id="element-57">
              Política de Privacidad
            </button>
          </div>
        </div>
      </footer>

      {/* Terms Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-58">
        <div className="space-y-4" data-id="element-59">
          <p className="font-medium text-stone-800" data-id="element-60">
            Última actualización: {new Date().toLocaleDateString('es-AR')}
          </p>

          <h3 className="font-bold text-stone-800 mt-6" data-id="element-61">
            1. Aceptación de los Términos
          </h3>
          <p data-id="element-62">
            Al acceder y utilizar este sitio web y adquirir el producto
            "Cuidador Sin Caos", aceptás estos términos y condiciones en su
            totalidad.
          </p>

          <h3 className="font-bold text-stone-800 mt-6" data-id="element-63">
            2. Descripción del Producto
          </h3>
          <p data-id="element-64">
            "Cuidador Sin Caos" es un kit digital imprimible diseñado para
            ayudar a organizar el cuidado de personas mayores. El producto
            incluye plantillas, fichas y guías en formato digital (PDF) para uso
            personal.
          </p>

          <h3 className="font-bold text-stone-800 mt-6" data-id="element-65">3. Uso del Producto</h3>
          <p data-id="element-66">
            El producto es para uso personal y familiar únicamente. No está
            permitida la redistribución, reventa o uso comercial del material
            sin autorización expresa.
          </p>

          <h3 className="font-bold text-stone-800 mt-6" data-id="element-67">4. Entrega Digital</h3>
          <p data-id="element-68">
            Una vez completada la compra, recibirás acceso inmediato al material
            digital. Debido a la naturaleza del producto digital, no se aceptan
            devoluciones una vez descargado el material.
          </p>

          <h3 className="font-bold text-stone-800 mt-6" data-id="element-69">
            5. Limitación de Responsabilidad
          </h3>
          <p data-id="element-70">
            Este producto es una herramienta de organización y no constituye
            asesoramiento médico, legal o profesional. El uso del material es
            bajo tu propia responsabilidad.
          </p>

          <h3 className="font-bold text-stone-800 mt-6" data-id="element-71">
            6. Propiedad Intelectual
          </h3>
          <p data-id="element-72">
            Todo el contenido, diseño y material del kit está protegido por
            derechos de autor. Queda prohibida la reproducción total o parcial
            sin autorización.
          </p>

          <h3 className="font-bold text-stone-800 mt-6" data-id="element-73">7. Modificaciones</h3>
          <p data-id="element-74">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios serán efectivos desde su publicación en este
            sitio.
          </p>
        </div>
      </Modal>

      {/* Privacy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-75">
        <div className="space-y-4" data-id="element-76">
          <p className="font-medium text-stone-800" data-id="element-77">
            Última actualización: {new Date().toLocaleDateString('es-AR')}
          </p>

          <h3 className="font-bold text-stone-800 mt-6" data-id="element-78">
            1. Información que Recopilamos
          </h3>
          <p data-id="element-79">
            Recopilamos únicamente la información necesaria para procesar tu
            compra: nombre, dirección de correo electrónico y datos de pago
            (procesados de forma segura por nuestro proveedor de pagos).
          </p>

          <h3 className="font-bold text-stone-800 mt-6" data-id="element-80">
            2. Uso de la Información
          </h3>
          <p data-id="element-81">Tu información se utiliza exclusivamente para:</p>
          <ul className="list-disc pl-6 space-y-1" data-id="element-82">
            <li data-id="element-83">Procesar y entregar tu compra</li>
            <li data-id="element-84">Enviarte el acceso al producto</li>
            <li data-id="element-85">Comunicarnos contigo sobre tu pedido</li>
          </ul>

          <h3 className="font-bold text-stone-800 mt-6" data-id="element-86">
            3. Protección de Datos
          </h3>
          <p data-id="element-87">
            Implementamos medidas de seguridad para proteger tu información
            personal. No almacenamos datos de tarjetas de crédito; estos son
            procesados directamente por nuestro proveedor de pagos seguro.
          </p>

          <h3 className="font-bold text-stone-800 mt-6" data-id="element-88">
            4. Compartir Información
          </h3>
          <p data-id="element-89">
            No vendemos, intercambiamos ni transferimos tu información personal
            a terceros, excepto a proveedores de servicios necesarios para
            completar tu compra (procesador de pagos, servicio de email).
          </p>

          <h3 className="font-bold text-stone-800 mt-6" data-id="element-90">5. Cookies</h3>
          <p data-id="element-91">
            Este sitio puede utilizar cookies para mejorar tu experiencia de
            navegación y analizar el tráfico del sitio de forma anónima.
          </p>

          <h3 className="font-bold text-stone-800 mt-6" data-id="element-92">6. Tus Derechos</h3>
          <p data-id="element-93">
            Tenés derecho a acceder, rectificar o eliminar tus datos personales.
            Para ejercer estos derechos, podés contactarnos a través de los
            canales disponibles.
          </p>

          <h3 className="font-bold text-stone-800 mt-6" data-id="element-94">
            7. Cambios en esta Política
          </h3>
          <p data-id="element-95">
            Podemos actualizar esta política periódicamente. Te notificaremos
            sobre cambios significativos publicando la nueva política en este
            sitio.
          </p>
        </div>
      </Modal>
    </>;
}